<template>
  <model-table
    :collection="orderItems"
    :columns="[
      { field: 'id' },
      { field: 'type', component: OrderItemTypeCell },
      { field: 'order', component: 'model' },
      { field: 'state', component: OrderStateCell },
      { field: 'description' },
      { name: currentSite.itemPriceLabel, field: 'price', component: 'money' },
      { field: 'discountAmount', component: 'money' },
      { field: 'voucherAmount', component: 'money' },
      { field: 'redemptionTotal', component: 'money' },
      { field: 'taxAmount', label: $t('pricing.tax') + ' Amount', component: 'money' },
      { field: 'pointsUsed' },
      { field: 'deliveryType' },
      { field: 'collectedUser', component: 'model', classes: 'sensitive-column' },
      { field: 'collectedAt', component: 'date-time' }
    ]"
    :show-add="false"
    :show-edit="false"

    :cell-class="props => classesForItem(props.row)"
    :sort-by="sortBy"
    :descending="descending"
  />
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'

export default {
  name: 'OrderItemTable',
  components: {
    ModelTable
  },
  props: {
    transferId: {
      type: Number,
      required: false,
      default: null
    },
    voidTransferId: {
      type: Number,
      required: false,
      default: null
    },
    sortBy: {
      type: String,
      required: false,
      default: 'id'
    },
    descending: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      OrderStateCell
    })
  },
  methods: {
    classesForItem (orderItem) {
      if (orderItem.state === 'placed' || orderItem.state === 'paid') {
        return []
      } else if (orderItem.state === 'voided') {
        return ['bg-red-1']
      } else if (orderItem.state === 'draft') {
        return ['bg-grey-4']
      } else if (orderItem.state === 'canceled') {
        return ['bg-grey-2']
      } else {
        throw new Error('Unhandled Condition ' + orderItem.state)
      }
    }
  },
  configuration: ['currentSite'],
  models: {
    orderItems: {
      order: 'default',
      variables () {
        return {
          transferId: this.transferId,
          voidTransferId: this.voidTransferId
        }
      }
    }
  }
}
</script>
